<template>
  <div
    v-if="statusMessage"
    id="status-messages"
    class="status-messages_container"
    :class="statusType"
  >
    {{ statusMessage }}
    <template v-if="statusMessages === 'login-block'">
      <md-tooltip 
        md-direction="top"
        class="tooltip-small"
      >
        Suporte: 0800-643-8100
      </md-tooltip>
      <svg-loader
        id="info-icon"
        class="header-title-info-icon"
        src="/static/images/icon-info.svg"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import strings from '../../strings'

export default {
  name: 'StatusMessages',
  computed: {
    ...mapGetters(['statusMessages']),
    statusMessage: function () {
      if (this.statusMessages) {
        return strings.login[this.statusMessages].message
      }
      return ''
    },
    statusType: function () {
      if (this.statusMessages) {
        return strings.login[this.statusMessages].type
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
  /* COMPONENT: commom/StatusMessages.vue */
  .status-messages_container {
    font-size: 14px;
    text-align: left;
    color: #ff0f07;
    margin: 0;
    padding: 0;
    min-height: 20px;
  }
</style>
